"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _inputLabel = _interopRequireDefault(require("../../legacy/input-label"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["labelPosition", "showValue"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var labelStyles = {
  fontSize: 3,
  letterSpacing: "0.5px",
  lineHeight: 2,
  px: 1,
  py: 2
};
var InputLabelContainer = (0, _styledComponents["default"])(function (_ref) {
  var labelPosition = _ref.labelPosition,
      showValue = _ref.showValue,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "placeholder-label__InputLabelContainer",
  componentId: "sc-127dufw-0"
})(["transform:", ";pointer-events:none;transform-origin:0 0;", ";"], function (_ref2) {
  var showValue = _ref2.showValue;
  return showValue ? "translate3d(3px, -3px, 0) scale(0.71)" : "translate3d(0, 0, 0) scale(1)";
}, (0, _styles.transitionEase)("0.3s", ["transform"]));
var containerStyles = {
  left: 0,
  position: "absolute",
  right: 0,
  top: 0,
  zIndex: 1
};
var FieldLabel = (0, _styledComponents["default"])(_inputLabel["default"]).withConfig({
  displayName: "placeholder-label__FieldLabel",
  componentId: "sc-127dufw-1"
})(["", ";"], (0, _styles.transitionEase)("0.3s", ["color"]));

var Label = function Label(_ref3) {
  var error = _ref3.error,
      fieldId = _ref3.fieldId,
      label = _ref3.label,
      labelPosition = _ref3.labelPosition,
      showValue = _ref3.showValue,
      hasFocus = _ref3.hasFocus,
      hasHover = _ref3.hasHover;
  return /*#__PURE__*/_react["default"].createElement(InputLabelContainer, _extends({
    labelPosition: labelPosition,
    showValue: showValue
  }, containerStyles), /*#__PURE__*/_react["default"].createElement(FieldLabel, _extends({
    color: (0, _utils.getTextColor)({
      error: error,
      hasFocus: hasFocus,
      hasHover: hasHover
    }),
    display: "block",
    htmlFor: fieldId
  }, labelStyles), label));
};

Label.propTypes = {
  /** A boolean to represent whether the label should be disabled */
  error: _propTypes.bool,
  fieldId: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  hasFocus: _propTypes.bool,
  hasHover: _propTypes.bool,

  /** A node that represent form element label */
  label: _propTypes.node,

  /** A string to represent label position */
  labelPosition: _propTypes.string,

  /** A boolean or string to represent whether the label should show */
  showValue: _propTypes.bool
};
var _default = Label;
exports["default"] = _default;